import React, { lazy, Suspense } from 'react'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import './pages/login/styles.css';

const ActivateUser = lazy(() => import('./pages/activate-users/activate-users'));
const Login = lazy(() => import('./pages/login/Login'));
const AppComponent = lazy(() => import('./AppComponent'));
const Register = lazy(() => import('./pages/login/Register'));
const Unsubscribe = lazy(() => import('./pages/unsubscribe/Unsubscribe'));
const ViewMapping = lazy(() => import('./pages/mapping/ViewMapping'));
const ForgotPassword = lazy(() => import('./pages/login/ForgotPassword'));
const NotFound = lazy(() => import('./components/error/NotFound'));


function Main(props) {
    return (
        props.loggedIn ? <ProtectedRoutes /> : <UnProtectedRoutes />
    )
}

const UnProtectedRoutes = (props) => {
    return (
        <Suspense fallback={<div className='loader'></div>}>
            <Switch>
                <Route path='/' component={Login} exact />
                <Route path='/login' component={Login} exact />
                <Route path='/register' component={Register} exact />
                <Route path='/unsubscribe' component={Unsubscribe} exact />
                <Route path='/activate-user/:secret' component={ActivateUser} />
                <Route path='/view-mapping' component={ViewMapping} />
                <Route path='/forgot-password' component={ForgotPassword} />
                <Route path='/reactsignin' component={Login} />
                <Route path='*' component={NotFound} />
            </Switch>
        </Suspense>
    )
}

const ProtectedRoutes = (props) => {
    return (
        <Suspense fallback={<div className='loader'></div>}>
            <Route path='/' component={AppComponent} />
        </Suspense>
    )
}

const mapStateToProps = (state) => {
    return {
        loggedIn: state.commonReducer.loggedIn,
        learnerprofile: state.commonReducer.logindetails,
        dashboard_type: state.commonReducer.dashboard_type,
        saveLanguageWiseData: state.commonReducer.languageData
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        // Define your dispatch functions here
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Main);